var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSafety(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 74,
    viewBox: "0 0 60 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.58129 6.07062L29.67 0L56.7587 6.07062C57.4908 6.23473 58.1455 6.64565 58.6148 7.23556C59.0841 7.82546 59.3399 8.5591 59.34 9.31538V42.5176C59.3398 45.8014 58.5356 49.0343 56.999 51.9294C55.4624 54.8246 53.2407 57.2923 50.5313 59.1137L29.67 73.14L8.80869 59.1137C6.09973 57.2927 3.8784 54.8254 2.34178 51.9309C0.805163 49.0364 0.000779188 45.8041 0 42.5209V9.31538C0.000128695 8.5591 0.255946 7.82546 0.725232 7.23556C1.19452 6.64565 1.84922 6.23473 2.58129 6.07062ZM6.59333 11.9817V42.5176C6.59337 44.7067 7.12929 46.8619 8.15352 48.792C9.17775 50.7221 10.6586 52.3673 12.4647 53.5817L29.67 65.1511L46.8753 53.5817C48.6809 52.3676 50.1615 50.7229 51.1857 48.7934C52.2099 46.864 52.7461 44.7094 52.7467 42.5209V11.9817L29.67 6.81532L6.59333 11.9817ZM32.9667 29.9209H42.8567L26.3733 53.1927V36.57H16.4833L32.9667 13.2982V29.9209Z",
    fill: "#030762"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafety);
export default __webpack_public_path__ + "static/media/safety.6fd27169d1e8e72ec8859ffa4c8067ab.svg";
export { ForwardRef as ReactComponent };